import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import Text from '@/components-latest/primitives/Text';
import Avatar from '@/components-latest/primitives/Avatar';
import TimerTag from '@/components-latest/ui/OrdersPage/TImerTag/TimerTag';
import Styles from './CourierDetails.module.scss';
import Courrier from '@/components-latest/primitives/Icons/Courrier';
import Tag from '@/components-latest/primitives/Tag';  
import { useFlags } from 'launchdarkly-react-client-sdk'

interface ICourierDetailsProps {
  driverName: string;
  avatarUrl: string;
  remainingETA: number;
  totalTime: number;
  status: string;
  orderTime: number;
  onTimerEnd?: () => void;
}

const CourierDetails: React.FC<ICourierDetailsProps> = ({
  driverName,
  avatarUrl,
  remainingETA,
  totalTime,
  status,
  orderTime,
  onTimerEnd
}) => {
  const [persistedETA, setPersistedETA] = useState<number>(() => {
    const savedETA = localStorage.getItem('remainingETA');
    return savedETA ? parseInt(savedETA, 10) : remainingETA; 
  });

  const isTimerActive = status !== 'READY' && status !== 'ACCEPTED';
  const { store_web_app_courrier_management } = useFlags()
  useEffect(() => {
    if (isTimerActive) {
      localStorage.setItem('remainingETA', String(persistedETA));
    }
  }, [persistedETA, isTimerActive]);

  useEffect(() => {
    setPersistedETA(remainingETA);
  }, [remainingETA]);

  const isHistoryOrder = ['DELIVERED', 'CANCELLED', 'RETURNED','COMPLETED','REJECTED','PICKED_UP'].includes(status);

  const shouldDisplayTimer = ['READY', 'ACCEPTED'].includes(status) && remainingETA > 0 && !isHistoryOrder;

  return (
    <div className={clsx(Styles.driverDetails)}>
      <div className={Styles.user}>
        <Avatar size="small" string={driverName} image={avatarUrl} />
        <div>
          <Text className={Styles.userType} variant="nextOverline" weight="bold" gutter={4}>
            {'Courier'}
          </Text>
          <Text variant="nextBody" weight="bold">
            {driverName}
          </Text>
        </div>
      </div>

      {store_web_app_courrier_management && !isHistoryOrder && (
        <div className={clsx(Styles.tags, Styles.flexContainer)}>
          <Text variant="nextSubtitle" className={Styles.flexItem}>
            <Courrier />
            {' Arriving in '}
          </Text>
          {/* Display Timer for active orders only */}
          {shouldDisplayTimer ? (
            <TimerTag timeLeft={persistedETA} totalTime={totalTime} onTimerEnd={onTimerEnd} />
          ) : (
            <Tag variant="fill" size="medium" intent="positive" className={Styles.flexItem}>
              {' Arrived '}
            </Tag>
          )}
        </div>
      )}
    </div>
  );
};

export default CourierDetails;
